import { Stack, useTheme } from "@mui/material";
import type { FC } from "react";
import {
	Resources,
	useResource,
} from "web_myplann/Infrastructure/Translations/Resources";
import { InspirationScenarioCard } from "web_myplann/Inspiration/Components/InspirationScenarioCard";
import { useEarlyFreedomYearsLabel } from "web_myplann/Inspiration/EarlyFreedom/Hooks/useEarlyFreedomYearsLabel";
import type {
	EarlyFreedomScenario,
	EarlyFreedomScenarioKey,
} from "web_myplann/Inspiration/EarlyFreedom/Types/EarlyFreedomTypes";

const R = Resources.Inspiration.EarlyFreedom;

type Props = {
	scenarios: EarlyFreedomScenario[];
	selected: EarlyFreedomScenarioKey;
	onSelect: (key: EarlyFreedomScenarioKey) => void;
};

export const EarlyFreedomScenarioList: FC<Props> = ({
	scenarios,
	selected,
	onSelect,
}) => {
	const { t } = useResource();
	const theme = useTheme();
	const formatYears = useEarlyFreedomYearsLabel();

	return (
		<Stack direction="row" gap={theme.spacingTokens.sm}>
			{scenarios.map((scenario) => (
				<InspirationScenarioCard
					key={scenario.key}
					scenarioKey={scenario.key}
					rate={scenario.rate}
					value={formatYears(scenario.years)}
					note={
						scenario.targetAge !== null &&
						scenario.years !== null &&
						scenario.years > 0
							? t(R.ageLabel, { age: scenario.targetAge })
							: undefined
					}
					selected={scenario.key === selected}
					onClick={() => onSelect(scenario.key)}
				/>
			))}
		</Stack>
	);
};
